import React from 'react'

import './MultiSelect.sass'

type MultiSelectOption = string | { value: string, label: any }

interface MultiSelectProps extends React.HTMLProps<HTMLDivElement> {
  options: MultiSelectOption[]
  value?: string[]
  onChangeList?: (s: string[]) => void
}

const MultiSelect = ({ options, value = [], onChangeList, children, className, ...other }: MultiSelectProps) => {
  const toggleSelect = (s: string) => onChangeList?.(value.includes(s) ? value.filter(t => t !== s) : [...value, s])
  const cls = className ? 'multiselect ' + className : 'multiselect'

  return (
    <div {...other} className={cls} tabIndex={1}>
      {children}
      <MultiSelectValue options={options} value={value} />
      <span className="icon icon_angle-right" />

      <ul className="options">
        {options.map((option, i: number) => {
          const v = typeof option === 'string' ? option : option.value
          const l = typeof option === 'string' ? option : option.label
          return (
            <li
              key={i}
              className={value.includes(v) ? 'selected' : ''}
              onClick={() => toggleSelect(v)}
            >
              {l?.toLowerCase()}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

interface MultiSelectValueProps extends React.HTMLProps<HTMLDivElement> {
  options: MultiSelectOption[]
  value?: string[]
}

export const MultiSelectValue = ({ options, value }: MultiSelectValueProps) => {
  const currOpts = options.filter(opt => value.includes(typeof opt === 'string' ? opt : opt.value))
  const labels = currOpts.map(opt => typeof opt === 'string' ? opt : opt?.label)
  // Note: values not matching any option are silently ignored

  return (
    <span className="value">
      {labels?.length === 0 && 'Ninguna'}
      {labels?.length >= 1 && labels.join(', ')}
    </span>
  )
}

export default MultiSelect
